// extracted by mini-css-extract-plugin
export default {"input-container":"rich-text_input-container__gQJq8","container":"rich-text_container__uFtD3"};